<template>
  <v-checkbox
    :class="className"
    :color="color"
    :label="label"
    :disabled="disabled"
    :input-value="value"
    @change="updateValue"
  >
    <template v-slot:append><i class="fal fa-square" /></template>
    <template v-slot:prepend><i class="fal fa-check-square" /></template>
  </v-checkbox>
</template>


<script>
export default {
  name: 'PosCheckbox',
  props: {
    className: { type: String, default: '' },
    color: { type: String, default: 'success' },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    value: { type: [Number, Boolean], default: false },
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>
